module.exports = __webpack_public_path__ + "static/media/help.2d4834c4.svg";